module.exports = __webpack_public_path__ + "static/media/truffle-fr.83d04a86.jpg";